import React from 'react';
import { 
  Typography, 
  Grid,
  Box,
  withStyles
} from '@material-ui/core';
import { appStyles } from '../../styles';

const ValueWithPct = ({ val, total, classes }) => (
  <Box textAlign="center">
    <Typography className={classes.statsCellText}>{val.toFixed(1)}</Typography>
    <Typography className={classes.statsPctText}>({total > 0 ? ((val / total) * 100).toFixed(1) : '0.0'}%)</Typography>
  </Box>
);

const StatsHoursRow = ({ type, hours, classes }) => {
  if (!hours) return null;
  const base = hours.scheduled;

  return (
    <Grid container className={classes.statsTableRow} alignItems="center">
      <Grid item xs={3} sm={2}>
        <Typography className={classes.statsTypeText}>{type}</Typography>
      </Grid>
      <Grid item xs={8} sm={9}>
        <Grid container>
          <Grid item xs={2} align="center">
            <Typography className={classes.statsCellText}>{hours.scheduled.toFixed(1)}</Typography>
          </Grid>
          <Grid item xs={2} align="center"><ValueWithPct val={hours.flown} total={base} classes={classes}/></Grid>
          <Grid item xs={2} align="center"><ValueWithPct val={hours.lostCancelled} total={base} classes={classes}/></Grid>
          <Grid item xs={2} align="center"><ValueWithPct val={hours.lostUnderfly} total={base} classes={classes}/></Grid>
          <Grid item xs={2} align="center"><ValueWithPct val={hours.gainedOverfly} total={base} classes={classes}/></Grid>
          <Grid item xs={2} align="center"><ValueWithPct val={hours.upcoming} total={base} classes={classes}/></Grid>
        </Grid>
      </Grid>
      <Grid item xs={1} />
    </Grid>
  );
};

const StatsTableView = ({ data, showDetailedCnx, isHours, classes }) => {
  if (!data) return null;

  const sortedEntries = Object.entries(data).sort(([a], [b]) => a.localeCompare(b));

  if (isHours) {
    return (
      <Box>
        {sortedEntries.map(([type, stats]) => (
          <StatsHoursRow key={type} type={type} hours={stats.hours} classes={classes} />
        ))}
      </Box>
    );
  }

  const getPct = (val, total) => total > 0 ? ((val / total) * 100).toFixed(1) : '0.0';

  const ValueWithPctInternal = ({ val, total }) => (
    <Box textAlign="center">
      <Typography className={classes.statsCellText}>{val}</Typography>
      <Typography className={classes.statsPctText}>({getPct(val, total)}%)</Typography>
    </Box>
  );

  return (
    <Box>
      {sortedEntries.map(([type, stats]) => {
        return (
          <Grid container key={type} className={classes.statsTableRow} alignItems="center">
            <Grid item xs={3} sm={2}>
              <Typography className={classes.statsTypeText}>{type}</Typography>
            </Grid>
            <Grid item xs={8} sm={9}>
              <Grid container>
                {showDetailedCnx ? (
                  <>
                    <Grid item xs={1} align="center">
                      <Typography className={classes.statsCellText}>{stats.total}</Typography>
                    </Grid>
                    <Grid item xs={2} align="center"><ValueWithPctInternal val={stats.completed} total={stats.total}/></Grid>
                    <Grid item xs={1} align="center"><ValueWithPctInternal val={stats.unknown} total={stats.total}/></Grid>
                    <Grid item xs={2} align="center"><ValueWithPctInternal val={stats.byStatus['USER_CNX'] || 0} total={stats.total}/></Grid>
                    <Grid item xs={2} align="center"><ValueWithPctInternal val={stats.byStatus['MX_CNX'] || 0} total={stats.total}/></Grid>
                    <Grid item xs={2} align="center"><ValueWithPctInternal val={stats.byStatus['WX_CNX'] || 0} total={stats.total}/></Grid>
                    <Grid item xs={2} align="center"><ValueWithPctInternal val={stats.byStatus['OPS_CNX'] || 0} total={stats.total}/></Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={2} align="center">
                      <Typography className={classes.statsCellText}>{stats.total}</Typography>
                    </Grid>
                    <Grid item xs={3} align="center"><ValueWithPctInternal val={stats.completed} total={stats.total}/></Grid>
                    <Grid item xs={3} align="center"><ValueWithPctInternal val={stats.unknown} total={stats.total}/></Grid>
                    <Grid item xs={4} align="center"><ValueWithPctInternal val={stats.cancelled} total={stats.total}/></Grid>
                  </>
                )}
              </Grid>
            </Grid>
            <Grid item xs={1} />
          </Grid>
        );
      })}
    </Box>
  );
};

export default withStyles(appStyles)(StatsTableView);